import React ,{useRef ,useEffect}from 'react';
import './receivable-accounts.scss'
import IrtizaDynamicInputList from '../../software-dynamic/list-input';
import moment from 'moment'
import SecurityService from '../../security/security.service';
import receivableAccountsService from './receivable-accounts.service';
import ReceivableAccountsAdd from './receivable-accounts-add';
import AuditTableInput from '../../audit-table/audit-table'
import securityService from '../../security/security.service';


const receivableAccountsInput = (props) => {



// AccountID
// AccountCode	
// AccountTitle	
// AccountTitleShort
    let columns =[
        {  field: "AccountID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "AccountCode",headerText:'Account Code',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "AccountTitle",headerText:'Account Title',width:'100px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "AccountTitleShort",headerText:'Account Title Short',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]}
        
       ]

       const listActionComplete = (grid,args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        // Transactional	Inactive	AccountTypeID	OpeningBalance	CreditDays	CreditAmountLimit	ContactPerson	OfficeAddress	LandlineNumber	CellNumber	NTN	STRN	EmailAddress	AccountCategoryID	Aging
        // 0	0	1	0	0	0	-	-	-	-	-	-	-	1	0
        if (args.requestType == 'save' && args.action == 'add') {
          console.log(args)
            receivableAccountsService.insert({
                CompanyID:1,
                CompanyID:SecurityService.getCompanyIDLoggedInUserId(),
                AccountCode:args.data.AccountCode,
                AccountTitle:args.data.AccountTitle,
                AccountTitleShort:args.data.AccountTitleShort,
                Transactional: 1,
                Inactive:args.data.Inactive || 0,
                AccountTypeID:args.data.AccountTypeID || 1,
                OpeningBalance:args.data.OpeningBalance || 0,
                CreditDays:args.data.CreditDays || 0,
                CreditAmountLimit:args.data.CreditAmountLimit || 0,
                ContactPerson:args.data.ContactPerson || '-',
                OfficeAddress:args.data.OfficeAddress || '-',
                LandlineNumber:args.data.LandlineNumber || '-',
                CellNumber:args.data.CellNumber || '-',
                NTN:args.data.NTN || '-',
                STRN:args.data.STRN || '-',
                EmailAddress:args.data.EmailAddress || '-',
                AccountCategoryID:args.data.AccountCategoryID || 1,
                Aging:args.data.Aging || 0
            }
              ).then((res)=>{
              console.log(res)
              
              getListService()
              let AddData = {
                AccountTitle:args.data.AccountTitle,
                AccountTitleShort:args.data.AccountTitleShort,
              }
              // AuditTableInput.auditAdd(`ChartOfAccount`,`ChartOfAccount`,`AccountID`,AddData)
              })
          
        }
        if (args.requestType == 'save' && args.action == 'edit') {
          console.log(args)
            receivableAccountsService.update({
                AccountID:args.data.AccountID,
                AccountTitle:args.data.AccountTitle,
                AccountTitleShort:args.data.AccountTitleShort,
            }).then((res)=>{
              console.log(res)
              
              getListService()
              let EditData = {
                AccountTitle:args.data.AccountTitle,
                AccountTitleShort:args.data.AccountTitleShort,
              }
                        let totalColumns = Object.keys(EditData);
                        console.log(totalColumns)
                        // AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`ChartOfAccount`,args.data.AccountID)
              })
          
        }
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props.IsDialog == true ? true : false
       
        // Defines the  string
        // @default ReceivableAccounts${typeMode} 
        let ListSecurity='Receivable Accounts'
        let AddSecurity='Receivable Accounts'
        let EditSecurity='Receivable Accounts'
        let DeleteSecurity='Receivable Accounts'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions =['Add','Edit','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] ;

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'ReceivableAccounts' ,
                    TableID:'receivableAccountsID',
                   // Optional if Delete is Soft // TableSecurity:'receivableAccountsDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'ReceivableAccounts' ,TableID:'receivableAccountsID', Optional // TableSecurity:'receivableAccountsDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <IrtizaDynamicInputList
        Id='ReceivableAccounts'
        ListTitle='Receivable Accounts - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> receivableAccountsService.getReceivableAccountsForList(SecurityService.getCompanyIDLoggedInUserId())
                        }]}
        DefaultSortedColumnName={'AccountID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<ReceivableAccountsAdd CompanyID={SecurityService.getCompanyIDLoggedInUserId()} />
                // Dialog:[
                //   {
                //     Title:'Invoice Evaluation',
                //     Inputs:[
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null},
                //       {field:{id:'CurrencyID',value:'CurrencyName'},type:'dropdown',dataSource:{type:'Route',Route:'CurrencyName'},defaultValues:null},
                //       {field:'ExchangeRate'	,type:'float',defaultValues:null},
                //       {field:'HawalaCommissionPercent'	,type:'float',defaultValues:null},
                //       {field:{id:'CurrencyIDHawala',value:'CurrencyNameHawala	'},type:'dropdown',dataSource:{type:'Route',Route:'CurrencyName'},defaultValues:null},
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null},
                //       {field:{id:'MainInvoiceID',value:'InvoiceNo'},type:'dropdown',dataSource:{type:'Route',Route:'Invoice'},defaultValues:null}
                //     ]
                //   }
                // ]

            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
             AllowTemplate={allowTemplate}
            ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
             AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></IrtizaDynamicInputList>
            
            );
}



export default receivableAccountsInput;
